"use client";
import { WHATSAPP_TAGS } from "@/@core/enums/whatsapp_tags.enum";
import { useClientTranslation } from "@/app/i18n/client";
import WhatsappLinkWithBeacon from "@/components/WhatsappLinkWithBeacon";
import useGetWpHref from "@/hooks/useGetWpHref";
import useWhatsappContext from "@/hooks/useWhatsappContext";
import { CONTACT_PHONE_NUMBER } from "@/lib/constants";
import PlusSquareIcon from "@heroicons/react/24/solid/PlusCircleIcon";
import { useTranslation } from "@/hooks/translationContext";

export default function AddCompanyButton({ venue }: { venue?: string }) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation()
  const whatsappTags = useWhatsappContext();
  const getWhatsappHrefUrl = useGetWpHref();

  const translateValues = whatsappTags.getContext({
    venue: venue ?? ""
  });

  return (
    <div className="container pb-4">
      <WhatsappLinkWithBeacon
        title={t("company-discount-add-company-button")}
        href={getWhatsappHrefUrl({
          tag: venue ? WHATSAPP_TAGS.ADD_COMPANY_IN_VENUE_DETAIL : WHATSAPP_TAGS.ADD_COMPANY,
          phone: CONTACT_PHONE_NUMBER,
          translateValues
        })}
      >
        <div
          className="py-[9px] flex gap-2 h-[42px] md:h-16 rounded-2xl hover:bg-gray-secondary/30 duration-100 justify-center items-center text-sm border border-gray-secondary font-bold text-assistant container w-full max-lg:mx-[12.5px]"
        >
          <PlusSquareIcon className="size-6" />
          Şirketini Ekle
        </div>
      </WhatsappLinkWithBeacon>
    </div>
  );
}
